<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from "moment";
import { mapGetters, mapActions, mapState } from "vuex";
import { ModelListSelect } from "vue-search-select";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Patients Payment",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      print_status:"",
      test: {},
      current_date: moment(new Date()).format("YYYY-MM-DD"),
      title: "Patients Payment",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Patients Payment",
          active: true,
        },
      ],
      totalRows: 1,
      modeError: "",
      balanceError: "",
      transdateError: "",
      discError: "",
      qtyError: "",
      debtorError: "",
      addressError: "",
      contactError: "",
      amtError: "",
      dueDateError: "",
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "visit.patient.patient_name",
          sortable: true,
          label: "NAME",
        },
        {
          key: "visit.patient.patient_contact",
          sortable: true,
          label: "CONTACT",
        },
        {
          key: "services",
          sortable: true,
          label: "SERVICES",
        },
        {
          key: "totalBill",
          sortable: true,
          label: "TOTAL AMOUNT",
        },
        {
          key: "paid",
          sortable: true,
          label: "PAID",
        },
        {
          key: "discount",
          sortable: true,
          label: "DISCOUNT",
        },

        {
          key: "balance_field",
          sortable: true,
          label: "BALANCE",
        },
        {
          key: "invoice_field",
          sortable: true,
          label: "INVOICE",
        },

        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],

      // ACTIVE MODE ID
      model_id: "",
      // END ACTIVE MODEL ID
      // PATIENT SERVICES
      patient_services: {
        prescriptions: "",
        patientServices: "",
        completeTests: "",
        labRequests: "",
        patient: "",
      },
      // END PATIENT SERVICE
      // CLEAR BALANCE
      clear_balance: {
        paid: "",
        received: "0",
        amount: "",
        total: "",
        index: "",
        mode_type: "",
        pay_id: "",
        patient_name: "",
        transdate: "",
      },

      // MANAGE PRESCRIBED DRUGS
      manageDrugs: {
        patient: "",
        drugs: "",
      },

      editData: {
        id: "",
        visit_id: "",
        name: "",
        quantity: "",
        notDoctor: true,
      },
      deleteData: {
        id: "",
        name: "",
      },

      // CLOSE VISIT
      close_visit: {
        balance: "",
        patient_name: "",
        visit_id: "",
      },
      // END CLOSE VISIT

      // GENERATE INVOICE
      invoice: {
        debtor: "",
        pay_id: "",
        address: "",
        contact: "",
        balance: "",
        bal: "",
        due_date: "",
      },
      // END GENERATE INVOICE
      // DISCOUNT
      discount: {
        balance: "",
        pay_id: "",
        amount: 0,
        patient_name: "",
      },
      // END DISCOUNT
    };
  },
  computed: {
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapState("payments", ["print_reciept"]),
    ...mapGetters("payments", [
      "PatientPayments",
      "PaymentModes",
      "Print_reciept",
      "ClearStatus",
      "invoiceGenerateStatus",
      "DiscountStatus",
    ]),
    ...mapGetters("pharmacy", ["DispenseState"]),
    ...mapGetters("auth", ["user_permissions"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.PatientPayments ? this.PatientPayments.length : 1;
    },
  },
  watch: {
    print_reciept(newValue) {
      if (newValue == true && this.print_status == 'print') {
        window.open(
          `https://${window.location.host}/preciept?id=${btoa(this.clear_balance.pay_id)}`
        );

      }
    },
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeMode(this.model_id);
        if (this.notificationtype == "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.submitted = false;
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.PatientPayments ? this.PatientPayments.length : 1;
  },
  methods: {
    ...mapActions({
      FetchPatientPayments: "payments/fetchPatientPayments",
      FetchPaymentModes: "payments/fetchPaymentModes",
      ClearBalance: "payments/clearBalance",
      CloseVisit: "visits/closeVisit",
      GenerateInvoice: "payments/generateInvoice",
      FetchPaymentReciept: "payments/fetchPaymentReciept",
      FetchPatientInvoice: "payments/fetchPatientInvoice",
      AddDiscount: "payments/addDiscount",
      UpdateQuantity: "pharmacy/UpdatePrescription",
      DeletePrescription: "pharmacy/RemovePrescription",
    }),
    // PATIENT ALL SERVICES MODAL
    viewServices(data) {
      this.patient_services.labRequests = data.item.visit.labrequests;
      this.patient_services.completeTests = data.item.visit.completetests;
      this.patient_services.patientServices = data.item.visit.patientservices;
      this.patient_services.prescriptions = data.item.visit.prescriptions;
      this.patient_services.patient = data.item.visit.patient.patient_name;
    },
    resetServices() {
      this.patient_services.labRequests = "";
      this.patient_services.completeTests = "";
      this.patient_services.patientServices = "";
      this.patient_services.prescriptions = "";
      this.patient_services.patient = "";
    },
    // END PATIENT SERVICES

    // CLEAR BALANCE MODAL SHOW
    clear_model(data) {
      this.$store.commit("payments/PAYMENT_RECEIPT_EMPTY"),
        (this.clear_balance.amount = data.balance),
        (this.clear_balance.paid = data.paid),
        (this.clear_balance.total = data.totalBill),
        (this.clear_balance.transdate = this.current_date),
        (this.clear_balance.patient_name = data.visit.patient.patient_name),
        (this.clear_balance.pay_id = data.id);
    },

    //CLEAR BALANCE
    payBalance(modalId,print_status) {
      this.model_id = modalId;
      this.print_status = print_status;
      let amtPaid = parseInt(this.clear_balance.received);
      let toPay = parseInt(this.clear_balance.amount);
      if (this.clear_balance.mode_type == "" || this.clear_balance.mode_type == null) {
        this.modeError = "Please select payment mode to proceed";
        return;
      }
      if (this.clear_balance.transdate == "" || this.clear_balance.transdate == null) {
        this.transdateError = "Please select transaction date to proceed";
        return;
      } else {
        this.transdateError = "";
      }
      if (
        this.clear_balance.received == "" ||
        this.clear_balance.received == null ||
        this.clear_balance.received == "0"
      ) {
        this.balanceError = "Please enter paid mode to proceed";
        return;
      } else {
        this.balanceError = "";
      }
      if (amtPaid > toPay) {
        this.balanceError =
          "Amount (" + amtPaid + ") can not be greater than Balance (" + toPay + ")";
        return;
      } else {
        this.balanceError = "";
      }
      this.ClearBalance(this.clear_balance);
    },

    // CLEAR BALANCE MODAL RESET
    resetPayModal() {
      this.clear_balance.amount = "";
      this.clear_balance.received = "";
      this.clear_balance.paid = "";
      this.clear_balance.total = "";
      this.clear_balance.transdate = "";
      this.clear_balance.patient_name = "";
      this.clear_balance.pay_id = "";
      this.clear_balance.mode_type = "";

      this.transdateError = "";
      this.balanceError = "";
      this.modeError = "";
    },
    resetModeError() {
      this.modeError = "";
    },
    resetBalanceError() {
      this.balanceError = "";
    },
    resetDateError() {
      this.transdateError = "";
    },

    // DISCOUNT MODEL
    discountModal(data) {
      this.discount.balance = data.balance;
      this.discount.pay_id = data.id;
      this.discount.amount = 0;
      this.discount.patient_name = data.patient_name;
    },

    // ADD DISCOUNT
    saveDiscount(modalId) {
      this.model_id = modalId;
      // Exit when the form isn't valid
      let bal = parseInt(this.discount.balance);
      let disc = parseInt(this.discount.amount);
      if (disc > bal) {
        this.discError =
          "Discount (" + disc + ") can not be greater than Balance (" + bal + ")";
        return;
      } else {
        this.discError = "";
      }

      if (disc < 1) {
        this.discError = "Please enter discount amount to continue";
        return;
      } else {
        this.discError = "";
      }
      if (this.discount.amount == "" || this.discount.amount == null) {
        this.discError = "Please enter discount amount to continue";
        return;
      } else {
        this.discError = "";
      }

      this.AddDiscount(this.discount);
    },

    resetDiscountError() {
      this.discError = "";
    },

    resetDiscount() {
      this.discount.balance = "";
      this.discount.pay_id = "";
      this.discount.amount = 0;
      this.discount.patient_name = "";
      this.discError = "";
    },
    // SHOW PRESCRIPTION MANAGEMENT MODAL
    drugsModal(data) {
      this.manageDrugs.patient = data.visit.patient.patient_name;
      this.manageDrugs.drugs = data.visit.prescriptions;
    },

    resetDrugs() {
      this.manageDrugs.patient = "";
      this.manageDrugs.drugs = "";
    },

    //  EDIT PRESCRIBED DRUG==============
    //  SHOW EDIT MODAL
    showEditModal(item) {
      this.editData.id = item.id;
      this.editData.visit_id = item.visit_id;
      this.editData.name = item.pharmacyitem.drug;
      this.editData.quantity = item.dispensed;
      this.editData.medication = item.medication;
      this.editData.notDoctor = true;
    },
    //  CONFIRM CHANGES
    confirmEdit(modalId) {
      this.model_id = modalId;
      if (
        this.editData.quantity == "" ||
        this.editData.quantity == null ||
        this.editData.quantity == "0"
      ) {
        this.qtyError = "Quantity field is required or Delete it instead";
        return;
      }
      let qty = parseInt(this.editData.quantity);

      if (qty < 1) {
        this.qtyError = "Quantity can not be less than one, Delete it instead";
        return;
      }
      //dispatch to endpoint
      this.UpdateQuantity(this.editData);
    },

    //  RESET EDIT MODAL
    resetEdit() {
      this.qtyError = "";
      this.editData.quantity = "";
      this.editData.id = "";
      this.editData.name = "";
    },

    //  DELETE PRESCRIBED DRUG==============
    //  SHOW DELETE MODAL
    showDeleteModal(item) {
      this.deleteData.id = item.id;
      this.deleteData.name = item.pharmacyitem.drug;
    },

    //DELETE
    confirmDelete(modalId) {
      this.model_id = modalId;
      //dispatch to endpoint
      this.DeletePrescription(this.deleteData);
    },

    //  RESET DELETE MODAL
    resetDelete() {
      this.deleteData.id = "";
      this.deleteData.name = "";
    },

    //  RESET ERROR
    resetError() {
      this.qtyError = "";
      this.debtorError = "";
      this.addressError = "";
      this.contactError = "";
      this.amtError = "";
      this.dueDateError = "";
    },

    // GENERATE INVOICE
    InvoiceModal(data) {
      this.invoice.due_date = "";
      this.invoice.debtor = data.visit.patient.patient_name;
      this.invoice.pay_id = data.id;
      this.invoice.address = data.visit.patient.patient_address;
      this.invoice.contact = data.visit.patient.patient_contact;
      this.invoice.balance = data.balance;
      this.invoice.bal = data.balance;
    },
    handleInvoice(modalId) {
      this.model_id = modalId;
      if (this.invoice.debtor == "" || this.invoice.debtor == null) {
        this.debtorError = "This field is required";
        return;
      } else {
        this.debtorError = "";
      }

      if (this.invoice.due_date == "" || this.invoice.due_date == null) {
        this.dueDateError = "This field is required";
        return;
      } else {
        this.dueDateError = "";
      }

      if (this.invoice.address == "" || this.invoice.address == null) {
        this.addressError = "This field is required";
        return;
      } else {
        this.addressError = "";
      }

      if (this.invoice.contact == "" || this.invoice.contact == null) {
        this.contactError = "This field is required";
        return;
      } else {
        this.contactError = "";
      }

      if (
        this.invoice.balance == "" ||
        this.invoice.balance == null ||
        this.invoice.balance == 0
      ) {
        this.amtError = "This field is required";
        return;
      } else {
        this.amtError = "";
      }

      if (parseInt(this.invoice.balance) != parseInt(this.invoice.bal)) {
        this.amtError = "Invalid balance. Current balance is " + this.invoice.bal;
        return;
      } else {
        this.amtError = "";
      }

      // Exit when the form isn't valid
      this.GenerateInvoice(this.invoice);
    },

    resetInvoice() {
      this.invoice.due_date = "";
      this.invoice.debtor = "";
      this.invoice.pay_id = "";
      this.invoice.address = "";
      this.invoice.contact = "";
      this.invoice.balance = "";
      this.debtorError = "";
      this.addressError = "";
      this.contactError = "";
      this.amtError = "";
      this.dueDateError = "";
    },

    // CLOSE VISIT
    close_visit_mode(data, index) {
      this.close_visit.balance = data.balance;
      this.close_visit.patient_name = data.visit.patient.patient_name;
      this.close_visit.visit_id = data.visit.id;
      this.close_visit.index = index;
    },

    ClosePatientVisit() {
      this.CloseVisit(this.close_visit.visit_id);
      this.closeMode("modal-close_visit");
      this.$store.commit("payments/REMOVE_VISIT_OBJECT", this.close_visit.index);
    },

    resetClose() {
      this.close_visit.balance = "";
      this.close_visit.patient_name = "";
      this.close_visit.visit_id = "";
      this.close_visit.index = "";
    },

    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    closeMode(model_id) {
      this.$nextTick(() => {
        this.$bvModal.hide(model_id);
      });
    },
    // END VALIDATION
  },
  created() {
    this.FetchPatientPayments();
    this.FetchPaymentModes();
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="PatientPayments"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
                >services
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(services)="data">
                  <button
                    v-if="user_permissions ? user_permissions.view_services : false"
                    v-b-modal.all-services
                    class="btn btn-info btn-sm"
                    @click="viewServices(data)"
                  >
                    <i class="fa fa-eye"></i> view
                  </button>
                  <button
                    v-else
                    class="btn btn-outline-info btn-sm"
                    title="You are restricted"
                  >
                    <i class="fa fa-ban"></i> view
                  </button>
                </template>
                <template #cell(balance_field)="data">
                  {{ data.item.balance }}
                  <span v-if="user_permissions.clear_payments">
                    <button
                      v-if="data.item.balance > 0 && data.item.invoice == 0"
                      v-b-modal.modal-clear
                      class="btn btn-success mr-1 btn-sm"
                      @click="clear_model(data.item)"
                    >
                      <i class="fab fa-apple-pay fa-1x"></i> Pay
                    </button>
                    <button
                      v-else-if="data.item.balance > 0 && data.item.invoice != 0"
                      v-b-modal.modal-clear
                      class="btn btn-success btn-sm"
                      @click="clear_model(data.item)">
                      <i class="fab fa-apple-pay fa-1x"></i> Pay
                    </button>
                  </span>
                  <span v-else>
                    <button
                      class="btn btn-outline-success btn-sm"
                      title="You are restricted"
                    >
                      <i class="fa fa-ban"></i> Pay
                    </button>
                  </span>
                </template>
                <template #cell(invoice_field)="data">
                  <span v-if="data.item.invoiceId != 0 && data.item.balance > 0">
                    <router-link
                      v-if="user_permissions ? user_permissions.view_invoice : false"
                      class="btn btn-info btn-sm"
                      :to="{
                        name: 'PatientInvoiceDetails',
                        params: {
                          invoice_id: data.item.invoiceId,
                        },
                      }"
                    >
                      <i class="fas fa-file-invoice"></i> Invoice
                    </router-link>
                    <button
                      v-else
                      class="btn btn-outline-info btn-sm"
                      title="You are restricted"
                    >
                      <i class="fas fa-ban"></i> Invoice
                    </button>
                  </span>
                  <span v-else-if="data.item.invoiceId == 0 && data.item.balance > 0">
                    <button
                      v-if="user_permissions ? user_permissions.generate_invoice : false"
                      v-b-modal.generate_invoice
                      class="btn btn-primary btn-sm"
                      @click="InvoiceModal(data.item)"
                    >
                      <i class="fas fa-spinner"></i> Generate
                    </button>
                    <button
                      v-else
                      class="btn btn-outline-primary btn-sm"
                      @click="InvoiceModal(data.item)"
                    >
                      <i class="fas fa-ban"></i> Generate
                    </button>
                  </span>
                  <span v-else>
                    <i class="text-success">paid</i>
                  </span>
                </template>
                <template #cell(actions)="data">
                  <div style="display: inline-flex">
                    <!--discount-->
                    <span v-if="data.item.balance > 0">
                      <button
                        v-if="user_permissions ? user_permissions.add_discount : false"
                        v-b-modal.modal-discount
                        class="btn btn-dark btn-sm"
                        @click="discountModal(data.item)"
                      >
                        <i class="fas fa-cut"></i> Discount
                      </button>
                      <button
                        v-else
                        class="btn btn-outline-dark btn-sm"
                        title="You are restricted">
                        <i class="fas fa-ban"></i> Discount
                      </button>
                    </span>

                    <!--drugs-->
                    <span v-if="data.item.visit.prescriptions.length">
                      <button
                        v-b-modal.manage-drugs
                        class="btn btn-secondary btn-sm m-1"
                        @click="drugsModal(data.item)"
                        v-if="user_permissions ? user_permissions.manage_drugs : false"
                      >
                        <i class="fas fa-capsules"></i> Drugs
                      </button>
                      <button
                        v-else
                        class="btn btn-outline-secondary btn-sm m-1"
                        title="You are restricted"
                      >
                        <i class="fas fa-ban"></i> Drugs
                      </button>
                    </span>
                    <!--Visit closing-->
                    <button
                      v-if="user_permissions ? user_permissions.view_close_visit : false"
                      v-b-modal.modal-close_visit
                      class="btn btn-danger btn-sm mb-2 ml-2"
                      @click="close_visit_mode(data.item, data.index)">
                      <span><strong>X</strong></span> Close
                    </button>
                    <button v-else class="btn btn-outline-danger btn-sm mb-2">
                      <i class="fas fa-ban"></i> Close
                    </button>
                  </div>
                </template>
              </b-table>
              <div style="text-align: center">
                <h3 v-if="!PatientPayments" class="text-primary">
                  <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                  Please wait...
                </h3>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            <!-- VIEW SERVICES model -->
            <div class="row">
              <div class="col-sm-6 col-md-4 col-xl-3">
                <div class="my-4 text-center">
                  <b-modal
                    id="all-services"
                    size="lg"
                    @hidden="resetServices"
                    hide-footer
                  >
                    <template #modal-title>
                      <p class="text-uppercase">
                        ALL SERVICES FOR {{ patient_services.patient }}
                      </p>
                    </template>
                    <div class="table-responsive">
                      <table class="table table-bordered border-primary mb-0">
                        <thead>
                          <tr>
                            <th>SERVICE</th>
                            <th>AMOUNT</th>
                            <th>DATE</th>
                            <th>STATUS</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(serv, index) in patient_services.patientServices"
                            :key="index"
                          >
                            <td>{{ serv.otherservice.name }}</td>
                            <td>{{ serv.cost }}</td>
                            <td>{{ serv.date }}</td>
                            <td>
                              <span v-if="serv.status == 1">Done</span>
                              <span v-else>Pending</span>
                            </td>
                          </tr>
                        </tbody>
                        <tbody>
                          <tr
                            v-for="(serv, index) in patient_services.completeTests"
                            :key="index"
                          >
                            <td>{{ serv.labtest.name }}</td>
                            <td>{{ serv.cost }}</td>
                            <td>{{ serv.date }}</td>
                            <td>{{ "Done" }}</td>
                          </tr>
                        </tbody>
                        <tbody>
                          <tr
                            v-for="(serv, index) in patient_services.labRequests"
                            :key="index"
                          >
                            <td>{{ serv.labtest.name }}</td>
                            <td>{{ serv.cost }}</td>
                            <td>{{ serv.date }}</td>
                            <td>{{ "Pending" }}</td>
                          </tr>
                        </tbody>
                        <tbody>
                          <tr
                            v-for="(serv, index) in patient_services.prescriptions"
                            :key="index"
                          >
                            <td>{{ serv.pharmacyitem.drug }}</td>
                            <td>{{ serv.cost }}</td>
                            <td>{{ serv.date }}</td>
                            <td>
                              <span v-if="serv.status == 1">Dispensed</span>
                              <span v-else>Pending</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="modal-footer">
                      <button
                        class="btn btn-secondary"
                        @click="$bvModal.hide('all-services')"
                        type="button"
                      >
                        Close
                      </button>
                    </div>
                  </b-modal>
                </div>
              </div>
            </div>
            <!-- END VIEW SERVICES model-->

            <!-- Drugs management model -->
            <div class="row">
              <div class="col-sm-6 col-md-4 col-xl-3">
                <div class="my-4 text-center">
                  <b-modal id="manage-drugs" size="lg" @hidden="resetDrugs" hide-footer>
                    <template #modal-title>
                     <p class="text-uppercase">
                        Manage {{ manageDrugs.patient }} prescription
                      </p>
                    </template>
                    <div class="table-responsive">
                      <table class="table table-bordered border-primary mb-0">
                        <thead>
                          <tr>
                            <th>PRESCRIBED DRUGS</th>
                            <th>PRESCRIBED QTY</th>
                            <th>DISPENSABLE QTY</th>
                            <th>AMOUNT</th>
                            <th>STATUS</th>
                            <th>ACTION</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(drug, index) in manageDrugs.drugs" :key="index">
                            <td>{{ drug.pharmacyitem.drug }} {{ drug.status }}</td>
                            <td>
                              {{ drug.quantity }}
                            </td>
                            <td>
                              {{ drug.dispensed }}
                            </td>
                            <td>{{ drug.cost }}</td>
                            <td>
                              <span v-if="drug.status == 1">dispensed</span>
                              <span v-else>Pending</span>
                            </td>
                            <td>
                              <!-- Dispense one button -->
                              <b-button
                                v-if="drug.status == 0"
                                v-b-modal.edit-modal
                                @click="showEditModal(drug)"
                                size="sm"
                                title="Edit prescribed drug"
                                variant="primary"
                                ><i class="fa fa-edit"></i
                              ></b-button>
                              <i v-else>Dispensed</i>

                              <!-- Dispense one button -->
                              <b-button
                                v-if="drug.status == 0"
                                v-b-modal.delete-modal
                                @click="showDeleteModal(drug)"
                                size="sm"
                                title="Remove drug from prescription"
                                variant="danger"
                                ><i class="fa fa-times"></i
                              ></b-button>
                              <i v-else></i>
                            </td>
                          </tr>
                        </tbody>
                        <tbody>
                          <tr
                            v-for="(serv, index) in patient_services.completeTests"
                            :key="index"
                          >
                            <td>{{ serv.labtest.name }}</td>
                            <td>{{ serv.cost }}</td>
                            <td>{{ "Done" }}</td>
                          </tr>
                        </tbody>
                        <tbody>
                          <tr
                            v-for="(serv, index) in patient_services.labRequests"
                            :key="index"
                          >
                            <td>{{ serv.labtest.name }}</td>
                            <td>{{ serv.cost }}</td>
                            <td>{{ "Pending" }}</td>
                          </tr>
                        </tbody>
                        <tbody>
                          <tr
                            v-for="(serv, index) in patient_services.prescriptions"
                            :key="index"
                          >
                            <td>{{ serv.pharmacyitem.drug }}</td>
                            <td>{{ serv.cost }}</td>
                            <td>
                              <span v-if="serv.status == 1">Dispensed</span>
                              <span v-else>Pending</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="modal-footer">
                      <button
                        class="btn btn-secondary"
                        @click="$bvModal.hide('manage-drugs')"
                        type="button"
                      >
                        Close
                      </button>
                    </div>
                  </b-modal>
                </div>
              </div>
            </div>
            <!-- End Drugs management model-->

            <!-- EDIT PRESCRIBED DRUG -->
            <b-modal
              id="edit-modal"
              size="sm"
              ref="modal"
              hide-footer
              @hidden="resetEdit"
            >
              <template #modal-title>
                <p class="text-uppercase">{{ editData.name }}</p>
              </template>
              <div class="mb-3">
                <label>Dispensable Quantity:</label>
                <input
                  v-model="editData.quantity"
                  class="form-control"
                  type="number"
                  @input="resetError"
                  title="Edit Qty Being Dispensed"
                />
                <div class="text-danger" v-if="qtyError">
                  <em>{{ qtyError }}</em>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  class="btn btn-secondary"
                  @click="$bvModal.hide('edit-modal')"
                  type="button"
                >
                  Close
                </button>
                <button
                  class="btn btn-primary"
                  type="button"
                  @click="confirmEdit('edit-modal')"
                >
                  Save
                  <b-spinner
                    v-if="DispenseState"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- EDIT PRESCRIBED DRUG -->

            <!-- DELETE PRESCRIBED DRUG -->
            <b-modal id="delete-modal" ref="modal" hide-footer @hidden="resetDelete">
              <template #modal-title>
                <p class="text-uppercase">Delete {{ deleteData.name }}</p>
              </template>
              <h3 class="text-center">
                Are you sure to delete <code>{{ deleteData.name }}</code> prescription?
                <br />
                Click <code>REMOVE</code> to continue.
              </h3>
              <div class="modal-footer">
                <button
                  class="btn btn-secondary"
                  @click="$bvModal.hide('delete-modal')"
                  type="button"
                >
                  Close
                </button>
                <button
                  class="btn btn-danger"
                  type="button"
                  @click="confirmDelete('delete-modal')"
                >
                  Remove
                  <b-spinner
                    v-if="DispenseState"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- DELETE PRESCRIBED DRUG -->

            <!-- CLEAR BALANCE MODEL -->
            <div class="row">
              <div class="col-sm-6 col-md-4 col-xl-3">
                <div class="my-4 text-center">
                  <b-modal
                    id="modal-clear"
                    title-class="font-18"
                    @hidden="resetPayModal"
                    hide-footer>
                    <template #modal-title
                      ><p class="text-uppercase">
                        Clear balance for {{ clear_balance.patient_name }}
                      </p></template>
                    <b-form-group label="Transaction Date">
                      <b-form-input
                        type="date"
                        id="name-input"
                        @input="resetDateError"
                        v-model="clear_balance.transdate"
                      ></b-form-input>
                      <div class="text-danger" v-if="transdateError">
                        <em>{{ transdateError }}</em>
                      </div>
                    </b-form-group>
                    <b-form-group label="Total Bill">
                      <b-form-input readonly
                        v-model="clear_balance.amount"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group label="Enter amount">
                      <b-form-input
                          type="number"
                          placeholder="Enter amount to pay"
                          @input="resetBalanceError"
                          v-model="clear_balance.received"
                      ></b-form-input>
                      <div class="text-danger" v-if="balanceError">
                        <em>{{ balanceError }}</em>
                      </div>
                    </b-form-group>
                    <b-form-group label="Payment mode">
                      <model-list-select
                        :list="PaymentModes ? PaymentModes : []"
                        @input="resetModeError"
                        v-model="clear_balance.mode_type"
                        option-value="id"
                        option-text="mode"
                        placeholder="select payment mode"
                      >
                      </model-list-select>
                      <div class="text-danger" v-if="modeError">
                        <em>{{ modeError }}</em>
                      </div>
                    </b-form-group>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        @click="closeMode('modal-clear')"
                      >
                        Close
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="payBalance('modal-clear','exit')"
                      >
                        Clear and exit
                        <b-spinner
                          v-show="ClearStatus && print_status=='exit'"
                          style="float: right"
                          class="m-0"
                          small
                          variant="light"
                          role="status"
                        ></b-spinner>
                      </button>
                       <button
                        type="button"
                        class="btn btn-success"
                        @click="payBalance('modal-clear','print')"
                      >
                        Clear and print
                        <b-spinner
                          v-show="ClearStatus && print_status=='print'"
                          style="float: right"
                          class="m-0"
                          small
                          variant="light"
                          role="status"
                        ></b-spinner>
                      </button>
                    </div>
                  </b-modal>
                </div>
              </div>
            </div>
            <!-- END CLEAR BALANCE MODEL -->

            <!-- GENERATE INVOICE MODEL -->
            <div class="row">
              <div class="col-sm-6 col-md-4 col-xl-3">
                <div class="my-4 text-center">
                  <b-modal id="generate_invoice" @hidden="resetInvoice" hide-footer>
                    <template #modal-title
                      ><p class="text-uppercase">
                        Generate Invoice for {{ invoice.debtor }}
                      </p></template
                    >
                    <b-form-group label="NAME">
                      <b-form-input
                        @input="resetError"
                        id="name-input"
                        v-model="invoice.debtor"
                      ></b-form-input>
                      <div class="text-danger" v-if="debtorError">
                        <em>{{ debtorError }}</em>
                      </div>
                    </b-form-group>
                    <b-form-group label="Address">
                      <b-form-input
                        @input="resetError"
                        placeholder="Enter Address"
                        v-model="invoice.address"
                      ></b-form-input>
                      <div class="text-danger" v-if="addressError">
                        <em>{{ addressError }}</em>
                      </div>
                    </b-form-group>

                    <b-form-group label="CONTACT">
                      <b-form-input
                        @input="resetError"
                        placeholder="Enter contact"
                        v-model="invoice.contact"
                      ></b-form-input>
                      <div class="text-danger" v-if="contactError">
                        <em>{{ contactError }}</em>
                      </div>
                    </b-form-group>

                    <b-form-group label="Balance">
                      <b-form-input
                        @input="resetError"
                        placeholder="Enter balance"
                        v-model="invoice.balance"
                      ></b-form-input>
                      <div class="text-danger" v-if="amtError">
                        <em>{{ amtError }}</em>
                      </div>
                    </b-form-group>

                    <b-form-group label="Due Date">
                      <b-form-input
                        type="date"
                        @input="resetError"
                        v-model="invoice.due_date"
                      ></b-form-input>
                      <div class="text-danger" v-if="dueDateError">
                        <em>{{ dueDateError }}</em>
                      </div>
                    </b-form-group>

                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        @click="closeMode('generate_invoice')"
                      >
                        Close
                      </button>
                      <button
                        type="button"
                        @click="handleInvoice('generate_invoice')"
                        class="btn btn-primary"
                      >
                        Generate
                        <b-spinner
                          v-if="invoiceGenerateStatus"
                          class="m-0"
                          style="float: right"
                          small
                          variant="light"
                          role="status"
                        ></b-spinner>
                      </button>
                    </div>
                  </b-modal>
                </div>
              </div>
            </div>
            <!-- END GENERATE INVOICE MODEL -->

            <!-- DISCOUNT MODEL -->
            <div class="row">
              <div class="col-sm-6 col-md-4 col-xl-3">
                <div class="my-4 text-center">
                  <b-modal id="modal-discount" @hidden="resetDiscount" hide-footer>
                    <template #modal-title
                      ><p class="text-uppercase">
                        Add Discount to {{ discount.patient_name }}
                      </p></template
                    >
                    <b-form-group label="DISCOUNT AMOUNT">
                      <b-form-input
                        type="number"
                        @input="resetDiscountError"
                        placeholder="Enter amount reduce on the bill"
                        v-model="discount.amount"
                      ></b-form-input>
                      <div class="text-danger" v-if="discError">
                        <em>{{ discError }}</em>
                      </div>
                    </b-form-group>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        @click="closeMode('modal-discount')"
                      >
                        Close
                      </button>
                      <button
                        type="button"
                        @click="saveDiscount('modal-discount')"
                        class="btn btn-primary"
                      >
                        Submit
                        <b-spinner
                          v-show="DiscountStatus"
                          style="float: right"
                          class="m-0"
                          small
                          variant="light"
                          role="status"
                        ></b-spinner>
                      </button>
                    </div>
                  </b-modal>
                </div>
              </div>
            </div>
            <!-- END DISCOUNT MODEL -->

            <!-- CLOSE VISIT MODEL -->
            <b-modal id="modal-close_visit" hide-footer @hidden="resetClose">
              <template #modal-title
                ><p class="text-uppercase">
                  Close {{ close_visit.patient_name }}'s Visit
                </p></template
              >
              <h3 v-if="close_visit.balance > 0" class="text-danger text-center">
                Are you sure to close <b>{{ this.close_visit.patient_name }}</b
                >'s visit with a balance of <code>{{ this.close_visit.balance }}</code>
              </h3>
              <h3 v-else class="text-danger text-center">
                Are you sure you want to close <b>{{ this.close_visit.patient_name }}</b
                >'s visit
              </h3>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary float-start"
                  @click="closeMode('modal-close_visit')"
                >
                  cancel
                </button>
                <button
                  type="submit"
                  @click="ClosePatientVisit()"
                  class="btn btn-success"
                >
                  close visit
                </button>
              </div>
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
